import {
  ChainId,
  chainSettings,
  ChainType,
} from "@/constants/chain-specific/chains";
import type {
  TokenIndex,
  DefaultTokenListType,
  PinnedTokenListType,
} from "@/constants/project-specific/types";
import { SOCIALS, SOCIALS_DC } from "@/constants/project-specific/socials";
import type { Address } from "viem";
import type { RequiredAggregatorChainType } from "./project";

export const DEAD_ADDRESS: Address =
  "0x000000000000000000000000000000000000dEaD";

export const ETH_TOKENS: TokenIndex = {
  shiro: {
    address: "0xb0AC2b5a73da0e67A8e5489Ba922B3f8d582e058",
    decimals: 18,
    symbol: "SHIRO",
    name: "Shiro Neko",
    socials: SOCIALS.shiro,
    logo: "https://dd.dexscreener.com/ds-data/tokens/ethereum/0xb0ac2b5a73da0e67a8e5489ba922b3f8d582e058.png?size=lg&key=fe4a6b",
  },
};

export const SHIB_TOKENS: TokenIndex = {
  bone: chainSettings[ChainId.SHIBARIUM].nativeCurrency,
  wbone: {
    address: "0xC76F4c819D820369Fb2d7C1531aB3Bb18e6fE8d8",
    decimals: 18,
    symbol: "WBONE",
    name: "WBONE",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/bone.webp",
  },
  woofswap: {
    address: "0xd0daa7b6ff1b40d3cc6f0b2cf7e85cb993d1c834",
    decimals: 18,
    symbol: "WOOF",
    name: "WoofSwap Token",
    logo: "https://woofswap.finance/image/tokens/WOOF.png",
  },
  woofwbone: {
    address: "0x839FdB6cc98342B428E074C1573ADF6D48CA3bFd",
    decimals: 18,
    symbol: "WBONE-WOOF",
    name: "WoofSwap WBONE",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/bone.webp",
  },
  shiro: {
    address: "0x15dd0588dc6c75783b28905d416ae24fa234fb60",
    decimals: 18,
    symbol: "SHIRO",
    name: "Shiro Neko",
    socials: SOCIALS.shiro,
    logo: "https://dd.dexscreener.com/ds-data/tokens/ethereum/0xb0ac2b5a73da0e67a8e5489ba922b3f8d582e058.png?size=lg&key=fe4a6b",
  },
  numnum: {
    address: "0xE1D900ebeeADDb773B2711b051DbF9711a6e6D34",
    decimals: 18,
    symbol: "NUMNUM",
    name: "Dog Eat Treat",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/numnum.gif",
  },
  knbone: {
    address: "0x3358FCA51d7C0408750FBbE7777012E0b67C027F",
    decimals: 18,
    symbol: "KnBONE",
    name: "KnBONE",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/knbone.webp",
    socials: SOCIALS.knine,
  },
  treat: {
    address: "0x506d8d2d9c715Eb34F514cc3EF48C7aBD19e2bc7",
    decimals: 18,
    symbol: "TREAT",
    name: "Shiba Inu Treat",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/treat.webp",
    socials: SOCIALS.shib,
  },
  roar: {
    address: "0xd1cb43c9d1859E57057770CB9ed0398736ad9D6f",
    decimals: 18,
    symbol: "$ROAR",
    name: "Roaring Kitty",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/roar.webp",
    socials: SOCIALS.roar,
  },
  hero: {
    address: "0xDe80496FDE552Ed677E0F8a8E62669273CC36Ac5",
    decimals: 18,
    symbol: "HERO",
    name: "Krypto",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/hero.webp",
    socials: SOCIALS.bury,
  },
  chewyswap: {
    address: "0x2761723006d3Eb0d90B19B75654DbE543dcd974f",
    decimals: 18,
    symbol: "CHEWY",
    name: "ChewySwap",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/chewy.webp",
    socials: SOCIALS.chewyswap,
  },
  cfun: {
    address: "0x8cC82045E761329FA13C9b0A0a31d76615fEc109",
    decimals: 18,
    symbol: "CFUN",
    name: "Corrupt Fun",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/cfun.webp",
    socials: SOCIALS.cfun,
  },
  juan: {
    address: "0x35e0ECdA229F9723B7A7194589339b209be5526e",
    decimals: 18,
    name: "Juanito",
    symbol: "JUAN",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/juan.webp",
  },
  feed: {
    address: "0xe9Cb2D7ADC24Fc59FE00D6C0A0669BDF16805Fe0",
    decimals: 18,
    symbol: "FEED",
    name: "FEED",
    logo: "https://chewy.build/assets/dapp/images/feed.webp",
  },
  damn: {
    address: "0xeCe898EdCc0AF91430603175F945D8de75291c70",
    decimals: 18,
    symbol: "DAMN",
    name: "Sol Killer",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/damn.webp",
  },
  knine: {
    address: "0x91fbB2503AC69702061f1AC6885759Fc853e6EaE",
    decimals: 18,
    symbol: "KNINE",
    name: "K9 Finance DAO",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/knine.webp",
    socials: SOCIALS.knine,
  },
  skullz: {
    address: "0x5212B42ef96A47Af93F3a6c801227b650EDEb12f",
    decimals: 18,
    symbol: "SKULLZ",
    name: "Sideshow 404",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/skullz.webp",
    socials: SOCIALS.skullz,
  },
  usdt: {
    address: "0xaB082b8ad96c7f47ED70ED971Ce2116469954cFB",
    decimals: 6,
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/usdt.webp",
    symbol: "USDT",
    name: "Tether USD",
  },
  wbtc: {
    address: "0xE984D89fb00D0B44E798A55dc41EA598B0b0899d",
    decimals: 8,
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/wbtc.webp",
    symbol: "WBTC",
    name: "Wrapped Bitcoin",
  },
  leash: {
    address: "0x65218A41Fb92637254B4f8c97448d3dF343A3064",
    decimals: 18,
    symbol: "LEASH",
    name: "DOGE KILLER",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/leash.webp",
    priceDecimals: 8,
  },
  shib: {
    address: "0x495eea66B0f8b636D441dC6a98d8F5C3D455C4c0",
    decimals: 18,
    symbol: "SHIB",
    name: "SHIBA INU",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shib.webp",
    priceDecimals: 8,
    socials: SOCIALS.shib,
  },
  weth: {
    address: "0x8ed7d143Ef452316Ab1123d28Ab302dC3b80d3ce",
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/eth.webp",
    priceDecimals: 8,
  },
  shups: {
    address: "0x165E8b1FaEFf503963f113dc81aFc49CeA2bAbA9",
    decimals: 18,
    symbol: "SHUPS",
    name: "Shibarium Pups",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shups.webp",
    priceDecimals: 8,
    socials: SOCIALS.shups,
    fees: {
      buy: 300,
      sell: 450,
    }
  },
  hoichi: {
    address: "0x425E00BfB24796f178e733aec44e172757D0A75d",
    decimals: 18,
    name: "Hoichi",
    symbol: "HOICHI",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/hoichi.webp",
  },
  chwump: {
    address: "0xd5af002A9CD036f6c620595a048D7Ef2e2320a42",
    decimals: 18,
    symbol: "Chwump",
    name: "Chewy Trump",
    logo: "https://chewyswap.dog/images/109/tokens/0xd5af002A9CD036f6c620595a048D7Ef2e2320a42.webp",
    priceDecimals: 8,
  },
  dudu: {
    address: "0x9F56Cba9C3d4CD9f3d7b899eA0Ff8292fE8264A8",
    decimals: 18,
    symbol: "dudu",
    name: "Dudu",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/dudu.webp",
    priceDecimals: 8,
  },
  bylo: {
    address: "0x44d13D376a9fF3999B0f947b2C3c85a2cBf669E5",
    decimals: 18,
    symbol: "$Bylo",
    name: "Bylo",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/bylo.webp",
  },
  liger: {
    address: "0x6F63F2D9278fBC3C29CB0b0f20823190181c5EDa",
    decimals: 18,
    symbol: "LIGER",
    name: "MY FAVORITE ANIMAL",
    logo: "https://chewyswap.dog/images/109/tokens/0x6F63F2D9278fBC3C29CB0b0f20823190181c5EDa.webp",
  },
  ryoshi: {
    address: "0x3751D1A5e0CdDD08BF91A8e115E44BA5359e52B1",
    decimals: 18,
    symbol: "RYOSHI",
    name: `Ryoshi's Coin`,
    logo: "https://github.com/shibaone/shibarium-images/blob/main/assets/images/shibarium/0x3751d1a5e0cddd08bf91a8e115e44ba5359e52b1.png?raw=true",
  },
  punk: {
    address: "0x1Bf3f5b633800E6047dEb14cF14C4b49118a3570",
    decimals: 18,
    symbol: "PUNK",
    name: "PunkSwap Token",
    logo: "https://dd.dexscreener.com/ds-data/dexes/punkswap.png",
  },
  fatboshi: {
    address: "0x06d3625CF994808988a2800aDBb2cAAe69C0aA02",
    decimals: 18,
    name: "FATBOSHI",
    symbol: "FATBOSHI",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/fatboshi.webp",
  },
  pika: {
    address: "0x0b4FD6288b6d32171CC515bfFC9340026F56A358",
    decimals: 18,
    name: "Pre-sale Killer",
    symbol: "PIKA",
    logo: "https://github.com/shibaone/shibarium-images/blob/main/assets/images/shibarium/0x0b4fd6288b6d32171cc515bffc9340026f56a358.png?raw=true",
  },
  club: {
    address: "0xb34d6b4856AF54F841A6FFc6e3bf76d1e73e078c",
    decimals: 18,
    symbol: "CLUB",
    name: "Shib Club",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/club.webp",
  },
  pnutshib: {
    address: "0xdE22A4F6C94507898442465d32a03871E4dc11Eb",
    decimals: 18,
    symbol: "PNUTSHIB",
    name: "PNUTSHIB",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/pnutshib.webp",
  },
  amc: {
    address: "0xeD916cCaB104362159b787AF525328B85EA42825",
    decimals: 18,
    symbol: "AMC",
    name: "AMC",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/amc.webp",
  },
  xfund: {
    address: "0x89dc93C6c12CaE47aCAf4aD9305d7A442C30dBB2",
    decimals: 9,
    symbol: "xFUND",
    name: "unification.com/xfund",
    logo: "https://github.com/shibaone/shibarium-images/blob/main/assets/images/shibarium/0x89dc93c6c12cae47acaf4ad9305d7a442c30dbb2.png?raw=true",
  },
  shibinals: {
    address: "0xB9Ae1d4e474CC154F48e5C2f0559Eb3A78Ad1F09",
    decimals: 18,
    symbol: "Shibinals",
    name: "Shibs",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shibinals.webp",
  },
  shipa: {
    address: "0x632d1FF1fB27d88EDeDB90e70bFC094D7932A0ad",
    decimals: 18,
    symbol: "SHIPA",
    name: "Shipa",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shipa.webp",
  },
  some: {
    address: "0x3E07514349f5837fC6aE7A996b4D8E4d79a5F487",
    decimals: 18,
    symbol: "Shibarium of Meme",
    name: "SOME",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/some.webp",
  },
  thesirion: {
    address: "0x6dF1F0250C14131462143166313845A32B83D882",
    decimals: 18,
    symbol: "TSO",
    name: "Thesirion",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/thesirion.webp",
  },
  omnom: {
    address: "0x09Da9802e10054193D4Dc9E22dfbf3848E7c93a7",
    decimals: 18,
    symbol: "OMNOM",
    name: "Doge Eat Doge",
    logo: "https://raw.githubusercontent.com/omnomcommunity/tokenlist/refs/heads/main/token/omnom.gif",
  },
  // TAX TOKENS
  pooshi: {
    address: "0x5Bc161445f32170653eB61bdeCf80c9D7F5C345a",
    decimals: 9,
    name: "Pooshi",
    symbol: "POOSHI",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/pooshi.webp",
    fees: {
      buy: 500,
      sell: 500,
    },
  },
  mojo: {
    address: "0xebB6eE5467A7CF83AdEb63c7A903c804Dfdae371",
    decimals: 18,
    name: "Mojo",
    symbol: "MOJO",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/mojo.webp",
  },
  ryka: {
    address: "0x93060BF9540541BC00F6D5f144Ba3C0C9ed871f5",
    decimals: 18,
    name: "Ryoshis Katana",
    symbol: "Ryka",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/ryka.webp",
  },
  byte: {
    address: "0x4a54CF403B9c751b7b7177A5335E23f38f692944",
    decimals: 18,
    name: "BYTE Token",
    symbol: "BYTE",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/byte.webp",
  },
  bark: {
    address: "0xD2e9e1a41E97912F3f966A3553E4C9Bb6861f0a6",
    decimals: 18,
    name: "BARK",
    symbol: "BARK",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/bark.webp",
  },
  hachi: {
    address: "0xabe27F4d040B448fBa19E387b5f5707A75c4a66B",
    decimals: 18,
    symbol: "HACHI",
    name: "HACHI",
    logo: "https://www.dextools.io/resources/tokens/logos/shibarium/0xabe27f4d040b448fba19e387b5f5707a75c4a66b.jpg?1735364477017",
  },
  shytoshi: {
    address: "0xee70777C4649B7937A86343F5a54718892572859",
    decimals: 9,
    name: "Shytoshis Coin",
    symbol: "Shytoshi",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shytoshi.webp",
  },
  ltd: {
    address: "0x2aCe8fab52842BEDa0713282d96c683FBE00FF89",
    decimals: 18,
    symbol: "LTD",
    name: "LivingTheDream",
    logo: "https://dd.dexscreener.com/ds-data/tokens/ethereum/0x1fdb29ad49330b07ae5a87483f598aa6b292039e.png?size=lg&key=6af763",
    socials: SOCIALS.ltd,
    mainLpDex: "shibaswapv1",
    fees: {
      buy: 300,
      sell: 500,
    },
  },
  shifu: {
    address: "0x95e9F2Bf576DbA036A38e9659167788b518e56bb",
    decimals: 18,
    symbol: "SHIFU",
    name: "Shifu",
    logo: "https://dd.dexscreener.com/ds-data/tokens/ethereum/0x2cc7a972ebc1865b346085655f929abfa74cd4dc.png?key=95e1ba",
    socials: SOCIALS.shifu,
  },
  bury: {
    address: "0x4FC2281639F9441F0Fcb8b6D922038277c4408c1",
    decimals: 18,
    symbol: "BURY",
    name: "Bury",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/bury.webp",
    socials: SOCIALS.bury,
  },
  cent: {
    address: "0x3C9b2b930ed1B6040F8539CCeB35Dd189F4733dD",
    decimals: 18,
    symbol: "CENT",
    name: "1 CENT DREAM",
    logo: "https://assets.geckoterminal.com/xm1menc1771fmjr9cbf1qr5ox8zs",
    socials: SOCIALS.cent,
    mainLpDex: "shibaswapv1",
    fees: {
      buy: 100,
      sell: 100,
    },
  },
  snooze: {
    address: "0xEFBd1Ab4F6aCa4c26C716f5FEdC0067802c8FB97",
    decimals: 18,
    symbol: "SNOOZE",
    name: "SleepyShibs",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/snooze.webp",
    priceDecimals: 8,
    socials: SOCIALS.snooze,
    fees: {
      buy: 0,
      sell: 490,
    },
  },
  bonewhale: {
    address: "0x33cA1D9305D5bB1cbeba0440C1B0fD5e1f8C81B9",
    decimals: 18,
    symbol: "Bonewhale",
    name: "Bonewhale",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/bonewhale.webp",
    priceDecimals: 8,
    fees: {
      buy: 0,
      sell: 500,
    },
  },
  shibware: {
    address: "0xA77241231a899b69725F2e2e092cf666286Ced7E",
    decimals: 18,
    symbol: "ShibWare",
    name: "ShibWare",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shibtech.webp",
    priceDecimals: 8,
    fees: {
      buy: 500,
      sell: 500,
    },
  },
  fef: {
    address: "0x9Ee1fabE85A5A65C2b17Fd17D430FbF72FA895Af",
    decimals: 18,
    name: "Financial and Educational Freedom",
    symbol: "FEF",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/fef.webp",
    fees: {
      buy: 300,
      sell: 300,
    },
    socials: SOCIALS.fef
  },
  shit: {
    address: "0xe10EeeE98F64bFc3BB308A724Df7f22717DFa7Cb",
    decimals: 18,
    name: "SHIT Coin",
    symbol: "SHIT",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/shit.webp",
    fees: {
      buy: 310,
      sell: 310,
    },
  },
  beaf: {
    address: "0xfd722863BC1D8e771F9507A4cceF540416864567",
    decimals: 18,
    name: "Beaf Warket",
    symbol: "BEAF",
    logo: "https://chewyswap.dog/images/109/tokens/0xfd722863BC1D8e771F9507A4cceF540416864567.webp",
    fees: {
      buy: 1000,
      sell: 1000,
    },
  },
  sixtynine: {
    address: "0x4b46baE20730916CeeF88201FAC2945542A11A09",
    decimals: 18,
    name: "69",
    symbol: "69",
    logo: "https://chewyswap.dog/images/109/tokens/0xE063dAB453125460a158307B748692D9905a19D3.webp",
    fees: {
      buy: 500,
      sell: 500,
    },
  },
  tyson: {
    address: "0x8eD7A837a62759Ea22F5fAbEFf33227aEaAF65f4",
    decimals: 18,
    name: "Tyson",
    symbol: "BITCOIN",
    logo: "https://chewyswap.dog/images/109/tokens/0x8eD7A837a62759Ea22F5fAbEFf33227aEaAF65f4.webp",
    fees: {
      buy: 490,
      sell: 800,
    },
  },
  sog: {
    address: "0xa545EB65ADee9E81556646b2Cda633F02BDd6038",
    decimals: 18,
    name: "Shibarium OG",
    symbol: "SOG",
    logo: "https://chewyswap.dog/images/109/tokens/0xa545EB65ADee9E81556646b2Cda633F02BDd6038.webp",
  },
  sape: {
    address: "0x68722615D3601c0747d0c49315D8626F24606eb9",
    decimals: 18,
    name: "Shibarium Ape",
    symbol: "Sape",
    logo: "https://chewyswap.dog/images/109/tokens/0x68722615D3601c0747d0c49315D8626F24606eb9.webp",
    fees: {
      buy: 500,
      sell: 500,
    },
  },
  oscar: {
    address: "0x0E56b8f632215053c6fB214B14A294372195760f",
    decimals: 9,
    name: "Oscar",
    symbol: "OSCAR",
    logo: "https://chewyswap.dog/images/109/tokens/0x0E56b8f632215053c6fB214B14A294372195760f.webp",
    socials: SOCIALS.oscar,
  },
};

export const DOGE_TOKENS: TokenIndex = {
  doge: chainSettings[ChainId.DOGECHAIN].nativeCurrency,
  wdoge: {
    address: "0xB7ddC6414bf4F5515b52D8BdD69973Ae205ff101",
    decimals: 18,
    symbol: "WDOGE",
    name: "WDOGE",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/dogecoin.webp",
  },
  chewyswap: {
    address: "0x1b47A8ae20fC5DC87fe566E97E693Fa6c761C851",
    decimals: 18,
    symbol: "CHEWY",
    name: "ChewySwap",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/chewy.webp",
    socials: SOCIALS.chewyswap,
  },
  dogeshrek: {
    address: "0x2BE0096B24343549E34224aa9aa297E99961023D",
    decimals: 18,
    symbol: "DogeShrek",
    name: "DogeShrek",
    logo: "https://raw.githubusercontent.com/PooDoge/dogeshrek-tokenlist/main/tokens/dogeShrek.png",
  },
  dogecorn: {
    address: "0x8df9B21945ebaa75424730F85eCFf426C35F5EF8",
    decimals: 18,
    symbol: "Dogecorn",
    name: "Dogecorn",
    logo: "https://raw.githubusercontent.com/PooDoge/dogeshrek-tokenlist/main/tokens/dogecorn.png",
  },
  dc: {
    address: "0x7B4328c127B85369D9f82ca0503B000D09CF9180",
    decimals: 18,
    symbol: "DC",
    name: "Dogechain Token",
    logo: "https://raw.githubusercontent.com/PooDoge/dogeshrek-tokenlist/main/tokens/dcToken.png",
  },
  usdt: {
    address: "0xB6dc6C8b71e88642cEAD3be1025565A9eE74d1C6",
    decimals: 6,
    symbol: "USDT",
    name: "Tether USD",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/usdt.webp",
  },
  dinu: {
    address: "0x8a764cF73438dE795c98707B07034e577Af54825",
    decimals: 18,
    symbol: "DINU",
    name: "Doge Inu",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/dinu.webp",
  },
  tdh: {
    address: "0x35EA0c670eD9f54Ac07B648aCF0F2EB173A6012D",
    decimals: 18,
    symbol: "TDH",
    name: "The Drugged Huskies",
    logo: "https://raw.githubusercontent.com/PooDoge/dogeshrek-tokenlist/main/tokens/tdh.png",
    socials: SOCIALS_DC.tdh,
  },
  omnom: {
    address: "0xe3fcA919883950c5cD468156392a6477Ff5d18de",
    decimals: 18,
    symbol: "OMNOM",
    name: "Doge Eat Doge",
    logo: "https://raw.githubusercontent.com/omnomcommunity/tokenlist/refs/heads/main/token/omnom.gif",
  },
  weth: {
    address: "0xFF13A7A12fd485BC9687fF88D8Ae1A6b655Ab469",
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/eth.webp",
  },
  kib: {
    address: "0x1e1026ba0810e6391b0F86AFa8A9305c12713B66",
    decimals: 18,
    symbol: "KIB",
    name: "Kibble",
    logo: "https://dd.dexscreener.com/ds-data/dexes/kibbleswap.png",
  },
  poodoge: {
    address: "0x3f4aE49EABEa4cc250a640eEa788a321C0AE7EB2",
    decimals: 18,
    symbol: "Poo Doge",
    name: "Poo Doge",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/poodoge.webp",
    fees: {
      buy: 100,
      sell: 100,
    },
  },
  fpepe: {
    address: "0xA6D7137aF64280e3eb8715aB6766740984Dd35E7",
    decimals: 9,
    symbol: "FuckPepe",
    name: "FuckPepee",
    logo: "https://raw.githubusercontent.com/PooDoge/dogeshrek-tokenlist/main/tokens/fuckpepe.png",
    fees: {
      buy: 500,
      sell: 500,
    },
  },
  omnomx: {
    address: "0xF99d5d3C2D87d6e2cc25Cb4C900a02EdfCd84B49",
    decimals: 18,
    symbol: "OMNOMX",
    name: "OMNOMX",
    logo: "https://raw.githubusercontent.com/PooDoge/dogeshrek-tokenlist/main/tokens/omnomx.png",
    fees: {
      buy: 800,
      sell: 800,
    },
  },
  wojak: {
    address: "0x570C41a71b5e2cb8FF4445184d7ff6f78A4DbcBD",
    decimals: 18,
    symbol: "WOJK",
    name: "WOJAK",
    logo: "/images/dex/wojak.webp",
  },
  yode: {
    address: "0x6FC4563460d5f45932C473334d5c1C5B4aEA0E01",
    decimals: 18,
    symbol: "YODE",
    name: "YodeDEX Token",
    logo: "https://dd.dexscreener.com/ds-data/dexes/yodeswap.png",
  },
  dfruit: {
    address: "0x2A3C691e08262aC2406aB9C3ee106C59Fff3E5ec",
    decimals: 18,
    symbol: "DFRUIT",
    name: "Dragonfruit Protocol",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/dfruit.webp",
  },
  katz: {
    address: "0x446EB7770D4E34772b75b3C795D2c2cD00a19808",
    decimals: 18,
    symbol: "KATZ",
    name: "KATZ",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/katz.webp",
  },
  hcuye: {
    address: "0xA599c9F818276DF5b26514884ABE02e5de79EB9d",
    decimals: 18,
    symbol: "HCUYE",
    name: "HCUYE",
    logo: "https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokens/hcuye.webp",
  },
  dtools: {
    address: "0xB9fcAa7590916578087842e017078D7797Fa18D0",
    decimals: 18,
    symbol: "DTOOLS",
    name: "DogeTools",
    logo: "https://raw.githubusercontent.com/PooDoge/dogeshrek-tokenlist/main/tokens/dogetools.png",
    fees: {
      buy: 300,
      sell: 300,
    },
  },
  milk: {
    address: "0xc90163b8d53F319AbE68dd1d8ecC025c72eB3f04",
    decimals: 18,
    symbol: "MILK",
    name: "Cowaii Milk",
    logo: "/images/dex/cowaii.png",
  },
  noni: {
    address: "0xa4F9877A08F7639df15D506eAFF92Ab5E78273cd",
    decimals: 18,
    symbol: "NONI",
    name: "Fruits of Ryoshi",
    logo: "https://icons.llamao.fi/icons/protocols/fruits-of-ryoshi?w=48&h=48",
  },
};

export const pinnedTokens: PinnedTokenListType = {
  [109]: {
    default: [SHIB_TOKENS.chewyswap, SHIB_TOKENS.wbone, SHIB_TOKENS.knbone],
    commonBases: [SHIB_TOKENS.weth, SHIB_TOKENS.wbone, SHIB_TOKENS.chewyswap],
    basePairs: [
      SHIB_TOKENS.bone,
      SHIB_TOKENS.shiro,
      SHIB_TOKENS.chewyswap,
      SHIB_TOKENS.treat,
      SHIB_TOKENS.shib,
      SHIB_TOKENS.roar,
      SHIB_TOKENS.leash,
      SHIB_TOKENS.weth,
      SHIB_TOKENS.usdt,
      SHIB_TOKENS.wbtc,
      SHIB_TOKENS.numnum,
      SHIB_TOKENS.knbone,
      SHIB_TOKENS.knine,
      SHIB_TOKENS.oscar,
      SHIB_TOKENS.hero,
      SHIB_TOKENS.wbone,
      SHIB_TOKENS.juan,
      SHIB_TOKENS.shifu,
      SHIB_TOKENS.cfun,
      SHIB_TOKENS.chwump,
      SHIB_TOKENS.bury,
      SHIB_TOKENS.skullz,
      SHIB_TOKENS.tyson,
      SHIB_TOKENS.ryoshi,
      SHIB_TOKENS.snooze,
      SHIB_TOKENS.fef,
      SHIB_TOKENS.beaf,
      SHIB_TOKENS.shibware,
      SHIB_TOKENS.bonewhale,
      SHIB_TOKENS.bylo,
      SHIB_TOKENS.dudu,
      SHIB_TOKENS.damn,
      SHIB_TOKENS.feed,
      SHIB_TOKENS.ltd,
      SHIB_TOKENS.liger,
      SHIB_TOKENS.punk,
      SHIB_TOKENS.cent,
      SHIB_TOKENS.mojo,
      SHIB_TOKENS.shups,
      SHIB_TOKENS.pooshi,
      SHIB_TOKENS.pika,
      SHIB_TOKENS.shibinals,
      SHIB_TOKENS.thesirion,
      SHIB_TOKENS.woofswap,
      SHIB_TOKENS.club,
      SHIB_TOKENS.woofwbone
    ],
    display: [
      SHIB_TOKENS.shiro,
      SHIB_TOKENS.chewyswap,
      SHIB_TOKENS.treat,
      SHIB_TOKENS.shib,
      SHIB_TOKENS.roar,
      SHIB_TOKENS.leash,
      SHIB_TOKENS.weth,
      SHIB_TOKENS.fef,
      SHIB_TOKENS.usdt,
      SHIB_TOKENS.wbtc,
      SHIB_TOKENS.shiro,
      SHIB_TOKENS.numnum,
      SHIB_TOKENS.knbone,
      SHIB_TOKENS.knine,
      SHIB_TOKENS.oscar,
      SHIB_TOKENS.shifu,
      SHIB_TOKENS.cfun,
      SHIB_TOKENS.skullz,
      SHIB_TOKENS.ryoshi,
      SHIB_TOKENS.ltd,
      SHIB_TOKENS.cent,
    ],
    swapDefaultFrom: [SHIB_TOKENS.bone],
    swapNative: [SHIB_TOKENS.bone, SHIB_TOKENS.wbone, SHIB_TOKENS.woofwbone],
    swapDefaultTo: [SHIB_TOKENS.chewyswap],
  },

  [2000]: {
    default: [
      DOGE_TOKENS.doge,
      DOGE_TOKENS.wdoge,
      DOGE_TOKENS.chewyswap,
      DOGE_TOKENS.dc,
      DOGE_TOKENS.usdt,
      DOGE_TOKENS.omnom,
      DOGE_TOKENS.dogeshrek,
      DOGE_TOKENS.dogecorn,
      DOGE_TOKENS.hcuye,
      DOGE_TOKENS.dtools,
      DOGE_TOKENS.dinu,
      DOGE_TOKENS.tdh,
      DOGE_TOKENS.kib,
      DOGE_TOKENS.poodoge,
      DOGE_TOKENS.wojak,
      DOGE_TOKENS.yode,
      DOGE_TOKENS.weth,
      DOGE_TOKENS.dfruit,
      DOGE_TOKENS.katz,
      DOGE_TOKENS.fpepe,
      DOGE_TOKENS.omnomx,
    ],
    basePairs: [
      DOGE_TOKENS.doge,
      DOGE_TOKENS.wdoge,
      DOGE_TOKENS.chewyswap,
      DOGE_TOKENS.dc,
      DOGE_TOKENS.usdt,
      DOGE_TOKENS.omnom,
      DOGE_TOKENS.dogeshrek,
      DOGE_TOKENS.dogecorn,
      DOGE_TOKENS.dtools,
      DOGE_TOKENS.hcuye,
      DOGE_TOKENS.dinu,
      DOGE_TOKENS.tdh,
      DOGE_TOKENS.kib,
      DOGE_TOKENS.poodoge,
      DOGE_TOKENS.wojak,
      DOGE_TOKENS.yode,
      DOGE_TOKENS.weth,
      DOGE_TOKENS.dfruit,
      DOGE_TOKENS.katz,
      DOGE_TOKENS.fpepe,
      DOGE_TOKENS.omnomx,
    ],
    display: [
      DOGE_TOKENS.doge,
      DOGE_TOKENS.wdoge,
      DOGE_TOKENS.chewyswap,
      DOGE_TOKENS.dc,
      DOGE_TOKENS.usdt,
      DOGE_TOKENS.omnom,
      DOGE_TOKENS.dogeshrek,
      DOGE_TOKENS.dogecorn,
      DOGE_TOKENS.hcuye,
      DOGE_TOKENS.dtools,
      DOGE_TOKENS.dinu,
      DOGE_TOKENS.tdh,
      DOGE_TOKENS.poodoge,
      DOGE_TOKENS.wojak,
      DOGE_TOKENS.yode,
      DOGE_TOKENS.weth,
      DOGE_TOKENS.katz,
      DOGE_TOKENS.fpepe,
    ],
    swapNative: [DOGE_TOKENS.doge, DOGE_TOKENS.wdoge],
    swapDefaultFrom: [DOGE_TOKENS.doge],
    swapDefaultTo: [DOGE_TOKENS.chewyswap],
  },
  [1]: {
    default: [ETH_TOKENS.shiro],
    basePairs: [ETH_TOKENS.shiro],
    display: [ETH_TOKENS.shiro],
    swapNative: [ETH_TOKENS.shiro],
    swapDefaultFrom: [ETH_TOKENS.shiro],
    swapDefaultTo: [ETH_TOKENS.shiro],
  },
};

export const defaultTokenList: DefaultTokenListType = {
  [109]: SHIB_TOKENS.chewyswap,
  [2000]: DOGE_TOKENS.chewyswap,
};

export const tokenIndexes: Record<RequiredAggregatorChainType, TokenIndex> = {
  [ChainId.SHIBARIUM]: SHIB_TOKENS,
  [ChainId.DOGECHAIN]: DOGE_TOKENS,
};

export const FULL_ROUND_LOGOS: string[] = ["omnom.gif"];